import { restClient } from '@/Core'

export const UpdateExecutorAssignmentTask = async (uuid: string, fields: Record<string, any>): Promise<void> => {
    await restClient.patch(`/services/executor-assignments/${uuid}`, { json: fields })
}
